const ProjectCard = ({ item, i }) => {
  return (
    <div
      className=" flex flex-row flex-wrap justify-center rounded-[10px] text-start w-[345px] h-fit shadow-lg bg-[#d7d7d7] px-[24px] py-[18px] "
      key={i}
    >
      <img
        src={item.logo}
        alt="Project Logo"
        className=" w-[100%] h-[200px] mb-[26px] "
      />
      <h1 className=" text-black  font-bold text-3xl ">{item.title}</h1>
      <p className=" text-black  mt-[6px] text-2xl font-[400] overflow-auto h-32">
        {item.description}
      </p>
      <ul className=" w-[100%] mt-[14px] flex flex-row flex-wrap gap-[6px] list-none ">
        {item.skills.map((skill, id) => (
          <li
            key={id}
            className=" text-black text-2xl font-[400] rounded-[100px] bg-[#33333338] py-[2px] px-[32px] "
          >
            {skill}
          </li>
        ))}
      </ul>
      <div className="w-[100%] mt-[26px] flex justify-around  ">
        <button className=" text-3xl font[600] rounded-[100px] py-1 px-[32px] hover:border-yellow-500 border hover:bg-transparent bg-yellow-500 text-white hover:text-yellow-500 ">
          <a href={item.demo} target="_blank" rel="noreferrer">
            Demo
          </a>
        </button>
        <button className=" text-3xl font[600] rounded-[100px] py-1 px-[32px] hover:bg-yellow-500 border-[1px] border-yellow-500 btn-warning hover:text-white ">
          <a href={item.repo} target="_blank" rel="noreferrer">
            Repo
          </a>
        </button>
      </div>
    </div>
  );
};

export default ProjectCard;
